export default __webpack_public_path__ + "static/media/preventivo.57971723.svg";